import React, { useRef, useState } from "react";

import { YT_EMBED_URL, YT_THUMBNAIL_SMALL, YT_THUMBNAIL_URL, YT_VIDEO_ID_REGEX } from "../../routes/pages/helper";
import styles from "./GetIframeVideo.module.scss";

const GetIframeVideo = (props) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoId = props.url.match(YT_VIDEO_ID_REGEX)?.pop();
  const embedUrl = videoId ? YT_EMBED_URL.replace("[VIDEO_ID]", videoId) : "";
  const thumbnailUrl = videoId
    ? (props.small ? YT_THUMBNAIL_SMALL : YT_THUMBNAIL_URL).replace(
        "[VIDEO_ID]",
        videoId,
      )
    : "";

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPlaying(true);
  };

  return (
    <div className={`${styles.container} ${props.className || ""}`}>
      {!isPlaying ? (
        <iframe
          className={styles.iframeContainer}
          title={props.title}
          srcDoc={`<style>
            body, .full {
            width: 100%;
            height: 100%;
            margin: 0;
            position: absolute;
            display: flex;
            justify-content: center;
            object-fit: cover;
            cursor: pointer;
            align-items: center;
            }
            </style>
        <div
        onClick="window.parent.postMessage('videoPlayed','*');
         window.location.replace('${embedUrl}');"
        class='full'
        >
        <img
        src='${thumbnailUrl}'
        class='full'
        loading='lazy'
        />
        </div>
  
        `}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          {...props}
        />
      ) : (
        <iframe
          className={styles.iframeContainer}
          title={props.title}
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          {...props}
        />
      )}
      {!isPlaying && (
        <div className={styles.playIconOverlay} onClick={handleClick}>
          <svg className={styles.playIcon} viewBox="0 0 91 90" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 45C0.5 20.1472 20.6472 0 45.5 0C70.3528 0 90.5 20.1472 90.5 45C90.5 69.8528 70.3528 90 45.5 90C20.6472 90 0.5 69.8528 0.5 45Z" fill="white"></path>
            <path d="M60.8131 43.2292L39.8113 32.1541C39.4032 31.9414 38.9302 31.8198 38.4422 31.8021C37.9542 31.7843 37.4692 31.8712 37.0382 32.0534C36.6072 32.2357 36.2462 32.5066 35.9931 32.8377C35.74 33.1687 35.6043 33.5477 35.6001 33.9348V56.0564C35.6006 56.4449 35.7342 56.826 35.9867 57.1591C36.2392 57.4921 36.6011 57.7646 37.0338 57.9474C37.4665 58.1303 37.9537 58.2166 38.4435 58.1971C38.9333 58.1777 39.4072 58.0532 39.8146 57.8371L60.8164 46.7619C61.1809 46.5669 61.4794 46.304 61.6858 45.9962C61.8922 45.6885 62.0001 45.3454 62.0001 44.9969C62.0001 44.6484 61.8922 44.3053 61.6858 43.9975C61.4794 43.6898 61.1809 43.4269 60.8164 43.2319L60.8131 43.2292Z" fill="currentColor"></path>
          </svg>
        </div>
      )}
    </div>
  );
};
export default GetIframeVideo;